class FlexibleTabsDonation {
	constructor() {
		this.groupIndex = 0;
		this.frequencyIndex = 0;
		document.addEventListener('DOMContentLoaded', () => {
			this.initAllTabs();
			this.addEventListeners();
			this.activateDefaultDonation(0);
			this.hiJackDonations();
			const yesTab = document.querySelector(
				'.tab-container.honoured-container .tab-header[data-tab="0"]'
			);
			const noTab = document.querySelector(
				'.tab-container.honoured-container .tab-header[data-tab="1"]'
			);

			yesTab?.addEventListener('click', () => this.setTribute('Yes'));
			noTab?.addEventListener('click', () => this.setTribute('No'));
		});
	}

	activateDefaultDonation(index) {
		const value = index === 0 ? 25 : 100;

		// Find the visible donation tab (only one should be visible at a time)
		const visibleTab = document.querySelector(
			'.donation-tab[style*="display: block"]'
		);
		if (!visibleTab) return;

		// Find radios *only* within the visible donation tab
		visibleTab
			.querySelectorAll('input[name="wc_label_price"]')
			.forEach((radio) => {
				radio.parentElement.classList.toggle('wc-active', radio.value == value);
				if (radio.value == value) radio.click();
			});
	}

	initAllTabs() {
		// Show the first group by default
		this.showGroupTab(0);

		// Initialize all tab containers for each group
		document.querySelectorAll('.tab-container').forEach((tabContainer) => {
			const tabHeaders = tabContainer.querySelectorAll('.tab-header.initial');
			const hmContent = document.querySelectorAll(
				'.tab-container.honoured-container .tab-content'
			);

			hmContent[1].style.display = 'block';
			hmContent[1].classList.add('open');
			tabHeaders[0].classList.add('open');
			this.showGroupContent(0);
			this.showFrequncyContent(0);
		});
	}

	addEventListeners() {
		// Event delegation for group tabs
		if (document.querySelector('.tab-container.group-container')) {
			document
				.querySelector('.tab-container.group-container')
				.addEventListener('click', (event) => {
					if (event.target.closest('.tab-header')) {
						let groupIndex = event.target.closest('.tab-header').dataset.group;
						this.handleGroupTabClick(event);
						this.showGroupContent(groupIndex);
						this.groupIndex = groupIndex;
					}
				});
		}

		// Event delegation for frequency tabs
		if (document.querySelector('.tab-container.frequency-container')) {
			document
				.querySelector('.tab-container.frequency-container')
				.addEventListener('click', (event) => {
					if (event.target.closest('.tab-header')) {
						let frequencyIndex =
							event.target.closest('.tab-header').dataset.frequency;
						this.handleFrequencyTabClick(event);
						this.showFrequncyContent(frequencyIndex);
						this.frequencyIndex = frequencyIndex;
					}
				});
		}
		// Event delegation for honoured memember tab

		if (document.querySelector('.tab-container.honoured-container')) {
			document
				.querySelector('.tab-container.honoured-container')
				.addEventListener('click', (event) => {
					if (event.target.closest('.tab-header')) {
						document
							.querySelectorAll('.tab-container.honoured-container .tab-header')
							.forEach((tabHeader) => {
								tabHeader.classList.remove('open');
								tabHeader.nextElementSibling.classList.remove('open');
								tabHeader.nextElementSibling.style.display = 'none';
							});
						event.target.closest('.tab-header').classList.add('open');
						event.target.nextElementSibling.classList.add('open');
						event.target.nextElementSibling.style.display = 'block';
					}
				});
		}

		// Tribute name selection: sync hidden input when checkbox is selected
		document.addEventListener('change', (event) => {
			if (event.target.matches('.honoured-member-checkbox')) {
				const selectedName = event.target.value;
				document
					.querySelectorAll('.honoured-member-checkbox')
					.forEach((checkbox) => {
						if (checkbox !== event.target) checkbox.checked = false;
					});
				const hiddenInput = document.querySelector('#honoured_member_name');
				if (hiddenInput) hiddenInput.value = selectedName;
			}
		});
	}

	handleGroupTabClick(event) {
		const groupIndex = event.target.closest('.tab-header').dataset.group;
		this.showGroupTab(groupIndex);
	}

	handleFrequencyTabClick(event) {
		const frequencyIndex =
			event.target.closest('.tab-header').dataset.frequency;
		this.showDonationTab(this.groupIndex, frequencyIndex);
	}

	showGroupTab(groupIndex) {
		document
			.querySelectorAll('.donation-container')
			.forEach((groupContainer) => {
				groupContainer.style.display =
					groupContainer.dataset.dontaionGroup == groupIndex ? 'block' : 'none';
			});
		this.showDonationTab(groupIndex, this.frequencyIndex);
	}

	showDonationTab(groupIndex, donationIndex) {
		document
			.querySelectorAll(
				`.donation-container[data-dontaion-group="${groupIndex}"] .donation-tab`
			)
			.forEach((tab) => {
				tab.style.display =
					tab.dataset.donation == donationIndex ? 'block' : 'none';
			});
	}

	showGroupContent(groupIndex) {
		document
			.querySelectorAll('.tab-content[data-group]')
			.forEach((tabContent) => {
				tabContent.style.display = 'none';
			});
		document
			.querySelectorAll('.tab-header[data-group]')
			.forEach((tabHeader) => {
				tabHeader.classList.remove('open');
			});

		document
			.querySelector('.tab-header[data-group="' + groupIndex + '"]')
			.classList.add('open');

		document.querySelector(
			'.tab-content[data-group="' + groupIndex + '"]'
		).style.display = 'block';
	}

	showFrequncyContent(frequencyIndex) {
		document
			.querySelectorAll('.tab-content[data-frequency]')
			.forEach((tabContent) => {
				tabContent.style.display = 'none';
			});
		document
			.querySelectorAll('.tab-header[data-frequency]')
			.forEach((tabHeader) => {
				tabHeader.classList.remove('open');
			});

		document
			.querySelector('.tab-header[data-frequency="' + frequencyIndex + '"]')
			.classList.add('open');
		document.querySelector(
			'.tab-content[data-frequency="' + frequencyIndex + '"]'
		).style.display = 'block';
	}
	setTribute(value) {
		document
			.querySelectorAll('.widget_wc-donation-widget')
			.forEach((widget) => {
				// Create hidden input for tribute yes/no
				let tributeInput = widget.querySelector(
					'input[name="honoured_member_tribute"]'
				);
				if (!tributeInput) {
					tributeInput = document.createElement('input');
					tributeInput.type = 'hidden';
					tributeInput.name = 'honoured_member_tribute';
					widget.appendChild(tributeInput);
				}
				tributeInput.value = value;

				// ✅ Create hidden input for selected name
				let nameInput = widget.querySelector(
					'input[name="honoured_member_name"]'
				);
				if (!nameInput) {
					nameInput = document.createElement('input');
					nameInput.type = 'hidden';
					nameInput.name = 'honoured_member_name';
					nameInput.id = 'honoured_member_name';
					widget.appendChild(nameInput);
				}
			});
	}

	hiJackDonations() {
		jQuery(document).ajaxSend(function (event, jqXHR, settings) {
			if (
				settings.url.includes('admin-ajax.php') &&
				settings.data.includes('wc_donation_add_to_cart')
			) {
				const tributeName = document.querySelector(
					'.honoured-member-checkbox:checked'
				)?.value;

				if (tributeName) {
					const formData = new FormData();
					settings.data.split('&').forEach((pair) => {
						const [key, value] = pair.split('=');
						formData.append(decodeURIComponent(key), decodeURIComponent(value));
					});
					formData.append('honoured_member_name', tributeName);

					jqXHR.abort(); // cancel original
					jQuery.ajax({
						url: settings.url,
						type: 'POST',
						data: formData,
						processData: false,
						contentType: false,
					});
				}
			}
		});
	}
}

export default FlexibleTabsDonation;
